import clsx from "clsx"
import { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import { getHowItWorksImg } from "../../helpers/getHowItWorksImg.ts"
import { HowItWorksImg } from "../HowItWorksImg"
import { HowItWorksText } from "../HowItWorksText"
import { HowItWorksTitle } from "../HowItWorksTitle"
import styles from "./HowItWorksSlide.module.scss"
import { IHowItWorksSlide } from "./types.ts"

export const HowItWorksHowToPlaySlide: FC<IHowItWorksSlide> = ({
  language
}) => {
  const { t } = useTranslation("howItWorks")
  return (
    <div className={clsx(styles.HowItWorksSlide, styles.slide_howToPlay)}>
      <HowItWorksTitle>{t("slides.howToPlay.title")}</HowItWorksTitle>
      <HowItWorksText>
        <ul>
          <li>
            <Trans
              i18nKey="slides.howToPlay.text1"
              ns="howItWorks"
              components={{ span: <span />, br: <br /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="slides.howToPlay.text2"
              ns="howItWorks"
              components={{ span: <span />, br: <br /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="slides.howToPlay.text3"
              ns="howItWorks"
              components={{ span: <span />, br: <br /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="slides.howToPlay.text4"
              ns="howItWorks"
              components={{ span: <span />, br: <br /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="slides.howToPlay.text5"
              ns="howItWorks"
              components={{ span: <span />, br: <br /> }}
            />
          </li>
        </ul>
      </HowItWorksText>
      <HowItWorksImg
        className={clsx(styles.HowItWorksSlide_img)}
        src={getHowItWorksImg("howToPlay", language)}
      />
    </div>
  )
}
